<template>
  <div class="shop-collapsible">
    <details v-for="item of items" :key="item.id" @click="onClick" :data-id="item.id">
      <summary>
        <slot name="summary" :item="item">{{ item.label }}</slot>
        <slot name="icon"><Icon icon="fa-pro-regular:angle-down" size="lg" /></slot>
      </summary>

      <div class="shop-collapsible__content">
        <slot :name="[item.id]" :item="item">{{ item.data }}</slot>
      </div>
    </details>
  </div>
</template>

<script>
import Icon from '@kvass/vue2-icon'

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    initial: Array,
  },
  watch: {
    items: {
      handler: 'init',
      immediate: true,
    },
  },
  methods: {
    onClick(event) {
      if (this.multiple) return
      const details = Array.from(this.$el.querySelectorAll('details'))
      const target = event.target.closest('details')

      details.forEach(el => {
        if (target === el) return
        el.open = false
      })
    },
    init() {
      this.$nextTick(() => {
        if (!this.initial || !this.initial.length) return

        this.initial.forEach(initial => {
          const target = this.$el.querySelector(`details[data-id="${initial}"]`)
          if (!target) return

          target.open = true
        })
      })
    },
  },
  components: {
    Icon,
  },
}
</script>

<style lang="scss">
.shop-collapsible {
  --shop-collapsible-padding: 1rem 1.2rem;

  details {
    border-top: 1px solid var(--border-color);

    &:last-child {
      border-bottom: 1px solid var(--border-color);
    }

    &[open] {
      background-color: rgba(black, 0.025);

      summary {
        svg {
          transform: rotate(-180deg);
        }
      }
    }
  }

  summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-grow: 1;

    user-select: none;
    cursor: pointer;

    padding: var(--shop-collapsible-padding);

    font-weight: bold;

    svg {
      transition: all 0.1s;
      transform-origin: 50% center;
    }

    &::-webkit-details-marker {
      display: none;
    }
  }

  &__content {
    padding: var(--shop-collapsible-padding);
    padding-top: 0;
  }
}
</style>
